import { create } from 'zustand';
import type { PendingRetry } from '../types';

type State = {
  pending: Record<string, PendingRetry>;
  setPendingRetry: (retry: PendingRetry) => void;
  clearPendingRetry: (tabId: string) => void;
  getPendingRetry: (tabId: string) => PendingRetry | null;
};

export const usePendingRetryStore = create<State>((set, get) => ({
  pending: {},
  setPendingRetry: (retry) => {
    if (retry.requires.length === 0) return;
    set((s) => ({ pending: { ...s.pending, [retry.tabId]: retry } }));
  },
  clearPendingRetry: (tabId) =>
    set((s) => {
      if (!(tabId in s.pending)) return s;
      const next = { ...s.pending };
      delete next[tabId];
      return { pending: next };
    }),
  getPendingRetry: (tabId) => get().pending[tabId] ?? null,
}));
